import { motion } from 'framer-motion';

const Redaction = ({ children, revealed, delay = 0 }) => (
  <span style={{ position: 'relative', display: 'inline-block', overflow: 'hidden' }}>
    <span style={{ opacity: revealed ? 1 : 0 }}>{children}</span>
    <motion.span
      style={{ position: 'absolute', inset: 0, background: '#F2F2F2' }}
      initial={{ x: '0%' }}
      animate={{ x: revealed ? '105%' : '0%' }}
      transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1], delay }}
    />
  </span>
);

export default Redaction;
